import {useWFHooks} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/wfReactInterface/context';
import {useHasTraceServerClientContext} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/pages/wfReactInterface/traceServerClientContext';
import React from 'react';

import {SkeletonCell} from './SkeletonCell';
import {useTracesCountsContext} from './TracesCountsContext';

type TracesCountCellProps = {
  id: string;
  entityName: string;
  projectName: string;
};

export const TracesCountCell: React.FC<TracesCountCellProps> = ({
  id,
  entityName,
  projectName,
}) => {
  const {useCallsStats} = useWFHooks();
  const hasTraceServer = useHasTraceServerClientContext();
  const shouldSkip = !hasTraceServer;
  const {result, loading} = useCallsStats({
    entity: entityName,
    project: projectName,
    skip: shouldSkip,
  });

  const {allLoaded, markLoaded, registerId} = useTracesCountsContext();
  const [registered, setRegistered] = React.useState(false);

  React.useEffect(() => {
    registerId(id);
    setRegistered(true);
  }, [id, registerId]);

  React.useEffect(() => {
    if (registered && (!hasTraceServer || !loading)) {
      markLoaded(id);
    }
  }, [registered, loading, hasTraceServer, id, markLoaded]);

  if (!allLoaded) {
    return <SkeletonCell />;
  }

  return (
    <div className="truncate p-3">{(result?.count ?? 0).toLocaleString()}</div>
  );
};
